export const FILE_TYPE = [
  { name: 'Education', id: 1 },
  { name: 'Fees', id: 2 },
  { name: 'Evidence File', id: 3 },
  { name: 'Form', id: 4 },
  { name: 'Certification', id: 5 },
  { name: 'General', id: 6 },
  { name: 'Score Letter', id: 7 },
  { name: 'License Verification', id: 8 },
  { name: 'License Confirmation', id: 9 },
  { name: 'License Renewal', id: 10 },
];

export enum FIELD_TYPE {
  SHORT_TEXT = 'shortText',
  DATE = 'date',
  RADIO_GROUP = 'radioGroup',
  PHONE = 'phone',
  LONG_TEXT = 'longText',
  CHECKBOX = 'checkbox',
  IMAGE_FILE = 'imageFile',
  FULL_NAME= 'fullName',
  EMAIL = 'email',
  US_ADDRESS = 'usAddress',
  NUMBER = 'number',
  DOLLAR = 'dollar',
  INTEGER = 'integer',
  PERCENT = 'percent',
  CHAR_LIST = 'charList',
  TEXT_WRAP = 'textWrap',
}